import { http } from 'shared/api/http';

function buildQS(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    qs.set(k, String(v));
  });
  return qs.toString();
}

export const membersApi = {
  create(dto) {
    return http('/api/v1/pilates/members', { method: 'POST', body: dto });
  },

  detail(id) {
    return http(`/api/v1/pilates/members/${id}`, { method: 'GET' });
  },

  memberPackages(memberId) {
    return http(`/api/v1/pilates/members/${memberId}/packages`, { method: 'GET' });
  },

  payments(memberId, params = {}) {
    const qs = buildQS({
      from: params.from,
      to: params.to,
      planId: params.planId,
      status: params.status,
    });
    const url = qs
      ? `/api/v1/pilates/members/${memberId}/payments?${qs}`
      : `/api/v1/pilates/members/${memberId}/payments`;
    return http(url, { method: 'GET' });
  },

  createPayment(dto) {
    return http('/api/v1/pilates/payments', { method: 'POST', body: dto });
  },

  pendingPayments() {
    return http('/api/v1/pilates/payments/pending', { method: 'GET' });
  },

  approvePayment(paymentId) {
    return http(`/api/v1/pilates/payments/${paymentId}/approve`, { method: 'POST' });
  },

  rejectPayment(paymentId, reason) {
    const qs = reason ? `?reason=${encodeURIComponent(reason)}` : '';
    return http(`/api/v1/pilates/payments/${paymentId}/reject${qs}`, { method: 'POST' });
  },

  earlyTransfer(memberId, dto) {
    return http(`/api/v1/pilates/members/${memberId}/early-transfer`, {
      method: 'POST',
      body: dto,
    });
  },

  createMemberPackage(memberId, dto) {
    return http(`/api/v1/pilates/members/${memberId}/packages`, {
      method: 'POST',
      body: dto,
    });
  },

  updatePayment(paymentId, dto) {
    return http(`/api/v1/pilates/payments/${paymentId}`, { method: 'PUT', body: dto });
  },

  deletePayment(paymentId) {
    return http(`/api/v1/pilates/payments/${paymentId}`, { method: 'DELETE' });
  },

  async list({ page = 0, size = 20, active, q } = {}) {
    const qs = buildQS({ page, size, active, q });
    const res = await http(`/api/v1/pilates/members?${qs}`, { method: 'GET' });

    if (res && Array.isArray(res.content)) {
      return { items: res.content, total: res.totalElements ?? res.content.length };
    }
    if (Array.isArray(res)) return { items: res, total: res.length };
    return { items: [], total: 0 };
  },

  renewPackage(memberId, dto) {
    return http(`/api/v1/pilates/members/${memberId}/packages/renew`, {
      method: 'POST',
      body: dto,
    });
  },

  editDetail(id) {
    return http(`/api/v1/pilates/members/${id}/edit`, { method: 'GET' });
  },

  update(id, payload) {
    return http(`/api/v1/pilates/members/${id}`, { method: 'PATCH', body: payload });
  },

  debt(memberId) {
    return http(`/api/v1/pilates/members/${memberId}/debt`, { method: 'GET' });
  },

  reduceDebt(memberId, dto) {
    return http(`/api/v1/pilates/members/${memberId}/debt/reduce`, {
      method: 'POST',
      body: dto,
    });
  },

  finishMemberPackage(memberId, packageId) {
    return http(`/api/v1/pilates/members/${memberId}/packages/${packageId}/finish`, {
      method: 'POST',
    });
  },

  activateMemberPackage(memberId, packageId) {
    return http(`/api/v1/pilates/members/${memberId}/packages/${packageId}/activate`, {
      method: 'POST',
    });
  },

  setActive(id, active) {
    return http(`/api/v1/pilates/members/${id}/active`, {
      method: 'PATCH',
      body: { active: !!active },
    });
  },

  validateDeleteMemberPackage(memberId, packageId) {
    return http(`/api/v1/pilates/members/${memberId}/packages/${packageId}/delete/validate`, {
      method: 'POST',
    });
  },

  deleteMemberPackage(memberId, packageId, { force = false } = {}) {
    const qs = force ? '?force=true' : '';
    return http(`/api/v1/pilates/members/${memberId}/packages/${packageId}${qs}`, {
      method: 'DELETE',
    });
  },

  updateMemberPackage(memberId, packageId, dto) {
    return http(`/api/v1/pilates/members/${memberId}/packages/${packageId}`, {
      method: 'PATCH',
      body: dto,
    });
  },

  async getMemberPackageDetail(memberId, packageId) {
    const list = await membersApi.memberPackages(memberId);
    const items = Array.isArray(list) ? list : list?.items ?? [];
    return items.find((x) => String(x?.id) === String(packageId)) || null;
  },
};
